(function() { window.GUID_3d51f1fd_6128_457a_bc18_2460eaa62e0c = { getGuid: function() { return "3d51f1fd-6128-457a-bc18-2460eaa62e0c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PopupWizardStep {
            constructor(wizard) {
                this.Wizard = wizard;
                this.$StepDiv = $("#" + wizard.ControlId + "-step-" + wizard.CurrentStep);
            }
            CheckIfCanContinue(callback) {
                let canContinue = this.OnCheckIfCanContinue();
                this.Wizard.SetNextButtonActive(canContinue);
                this.OnCheckIfCanContinueDone(canContinue);
            }
            OnLoad() { }
            OnPrevious() { }
            OnCheckIfCanContinueDone(canContinue) { }
            OnSubmit() { }
        }
        Controls.PopupWizardStep = PopupWizardStep;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=popup-wizard-step.js.map
